import { DatePicker as AntdDatePicker, Button, Card, ConfigProvider, Flex, Modal, Row, Space, Tabs } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as DateIcon } from "../../../assets/icon/dateIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as HistoryIcon } from "../../../assets/icon/historyIcon.svg";
import styles from "../styles/RequestApproval.module.css";
import PendingApprovalFilter from "./PendingApprovalFilter";
import DateRangePicker from "components/form/DatePicker/RangePicker";
import { FormDatePicker } from "components/form/FormProvide";
import ModalMyRequest from "components/elements/Modal/ModalMyRequest";

const PendingApprovalContent = ({
    onPendingTabChange = () => { },
    modifiedLeaveGroupOptions = [],
    modifiedEmployeeOptions = [],
    modifiedOffSiteOptions = [],
    modifiedMovementGroupOptions = [],
    modifiedDocumentTypeOptions = [],
    table = () => { },
    disabledDateRange = {},
    defaultValue = {},
    onSearch = () => { },
    setDefaultValue = () => { },
    pendingTab = "",
    modalHistory = () => { },
    handleOpenModal = () => { },
    handleOk = () => { },
    handleCancelModal = () => { },
    isModalOpen = false,
    modalOpen,
    onCancelModal = () => { },
    modalReTurn,
    useFilter,
    setUseFilter
}) => {


    const { t, i18n } = useTranslation();
    const { roles } = useSelector((state) => state.company);
    // const [useFilter, setUseFilter] = useState(false);


    return (
        <Flex vertical>
            <ConfigProvider
                theme={{
                    components: {
                        Tabs: {
                            itemHoverColor: "var(--tab-color)",
                            itemActiveColor: "var(--tab-color)"
                        },
                    },
                }}
            >
                <Tabs defaultActiveKey="PendingApprovalLeaveTable" onChange={onPendingTabChange} tabBarStyle={{ justifyContent: 'space-between' }}>
                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|LEAVE") &&
                        <Tabs.TabPane tab={t("leave-work")} key="PendingApprovalLeaveTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|OFFSITE_WORK") &&
                        <Tabs.TabPane tab={t("offsite-work")} key="PendingApprovalOffsiteWorkTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|REDEEM_TIME") &&
                        <Tabs.TabPane tab={t("redeem-time")} key="PendingApprovalRedeemTimeTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|ENDORSE_TIME") &&
                        <Tabs.TabPane tab={t("endorse-time")} key="PendingApprovalEndorseTimeTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|OVERTIME") &&
                        <Tabs.TabPane tab={t("overtime.header")} key="PendingApprovalOvertimeTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|COLLECT_TIME") &&
                        <Tabs.TabPane tab={t("collect-time")} key="PendingApprovalCollectTimeTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|EXPENSE") &&
                        <Tabs.TabPane tab={t("expense.header")} key="PendingApprovalExpenseTable" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|DOCUMENT_REQUEST") &&
                        <Tabs.TabPane tab={t("documents")} key="RequestForm" />}

                    {(roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST|CHANGE_SHIFT")) &&
                        <Tabs.TabPane tab={t("changeshift.label.changeshift")} key="ChangeShift" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|MOVEMENT") &&
                        <Tabs.TabPane tab={t("setting.movement")} key="Movement" />}

                    {roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST|WARNING_LETTER") &&
                        <Tabs.TabPane tab={t("warning-letter")} key="WarningLetter" />}

                    {/* {roles.includes("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|REQUEST_APPROVAL|HISTORY") &&
                    <Tabs.TabPane tab={<Flex style={{ gap: 4 }}>{t("history.header")}</Flex>} key="PendingApprovalHistoryTable" style={{ flex: 1 }} />} */}
                </Tabs>
            </ConfigProvider>
            <Flex vertical>
                <Row style={{ marginBottom: 12, justifyContent: "end" }} >
                    <Space direction="horizontal" size={8}>

                        <Button style={{ width: "max-content", height: "max-content", borderRadius: "8px", padding: "10px 16px" }}
                            onClick={handleOpenModal}
                        >
                            <Flex align="center" justify="center" gap={8}>
                                <HistoryIcon />
                                <span style={{ color: "#344054" }}>{t("becash.label.history")}</span>
                            </Flex>
                        </Button>

                        <ModalMyRequest
                            {...modalReTurn}
                            isModalOpen={modalOpen}
                            onCancel={onCancelModal}
                        />

                        <Modal title={t("becash.label.history")}
                            open={isModalOpen}
                            onOk={handleOk}
                            onCancel={handleCancelModal}
                            footer={false}
                            width="90%"
                            maskClosable={false}
                        >
                            {modalHistory()}
                        </Modal>

                        <FormDatePicker
                            name="dateSearch"
                            defaultValue={defaultValue}
                            picker="year"
                            dateFormat={"YYYY"}
                            disabledDate={(currentDate) => {
                                return (
                                    currentDate.isBefore(disabledDateRange.startYear) ||
                                    currentDate.isAfter(disabledDateRange.endYear)
                                );
                            }}
                            style={{ height: "44px", width: "110px", borderRadius: "8px" }}
                            suffixIcon={<DateIcon />}
                            // className={styles.datePickerReverse}
                            allowClear={false}
                            onChange={(date) => {
                                const selectedYear = date.year()
                                onSearch({ year: selectedYear.toString() });
                                setDefaultValue(date)
                            }}
                        />
                        {pendingTab !== "PendingApprovalHistoryTable" && (<Button type="default" onClick={() => setUseFilter(!useFilter)}
                            style={{ padding: "10px 16px", height: "max-content", borderRadius: "8px" }}
                        >
                            <Flex align="center" justify="center" gap={8}>
                                <FilterIcon />
                                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                            </Flex>
                        </Button>)}
                    </Space>
                </Row>
                <Space className={styles.container} direction="vertical" size={24}>
                    {(pendingTab != "PendingApprovalHistoryTable" && useFilter) && (
                        <Card width="100%" height="fit-content" style={{
                            borderRadius: "8px",
                            backgroundColor: "white",
                            border: "1px solid #EAECF0"
                        }}>
                            <PendingApprovalFilter
                                dataFlag={pendingTab}
                                leaveGroupOptions={modifiedLeaveGroupOptions}
                                employeeOptions={modifiedEmployeeOptions}
                                offsiteOptions={modifiedOffSiteOptions}
                                onSubmit={onSearch}
                                movementGroupOptions={modifiedMovementGroupOptions}
                                documentTypeOptions={modifiedDocumentTypeOptions}
                            />
                        </Card>
                    )}
                    {/* <CardContainer width="100%" height="fit-content"> */}
                    {table()}
                    {/* </CardContainer> */}
                </Space>
            </Flex>
        </Flex>



    )
}

export default PendingApprovalContent;